import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, PageHeader, Spinner, Badge, EmptyState } from "@/components/ui";
import { HeartPulse, ChevronRight } from "lucide-react";

export default function CarePlans() {
  const [plans, setPlans] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { api.get("/care-plans").then((r) => setPlans(r.data)); }, []);

  return (
    <div className="vc-fade-up">
      <PageHeader title="Care Plans" subtitle="Person-centered, evidence-based care plans across your managed population. Open a member to draft AI-assisted plans." />
      {plans === null ? <Spinner /> : plans.length === 0 ? <EmptyState title="No care plans yet" /> : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {plans.map((cp) => (
            <Card key={cp.id} className="p-5 cursor-pointer" hover onClick={() => navigate(`/members/${cp.member_id}`)} data-testid="careplan-card">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-2"><HeartPulse className="h-5 w-5 text-brand-700" /><h3 className="font-semibold">{cp.member_name}</h3></div>
                <Badge tone={cp.status}>{cp.status}</Badge>
              </div>
              <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-1.5">Goals</p>
              <ul className="space-y-1 mb-3">
                {cp.goals.slice(0, 3).map((g, i) => <li key={i} className="text-sm text-muted-foreground truncate">• {g.goal}</li>)}
              </ul>
              {cp.barriers?.length > 0 && (
                <div className="flex flex-wrap gap-1 mb-3">
                  {cp.barriers.map((b) => <span key={b} className="text-[10px] rounded bg-amber-50 text-amber-800 px-1.5 py-0.5">{b}</span>)}
                </div>
              )}
              <div className="flex items-center justify-between text-xs text-muted-foreground pt-3 border-t border-border">
                <span>By {cp.created_by}</span>
                <span className="flex items-center gap-1 text-brand-700 font-semibold">Open chart <ChevronRight className="h-3.5 w-3.5" /></span>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
